module.exports = __webpack_public_path__ + "static/title_bg-88e0126248248005238ffbd57828feb8.svg";